import { AdaptationLibraryFilterItem } from './adaptationLibrary.types'

export const FILTERS: AdaptationLibraryFilterItem[] = [
  'cost',
  'location',
  'lead_time',
  'timeframe',
  'para_category',
  'hazards_addressed',
  'risk_management_type',
]

export const INITIAL_FILTER_STATE = {
  cost: [],
  search: '',
  location: [],
  timeframe: [],
  lead_time: [],
  para_category: [],
  hazards_addressed: [],
  risk_management_type: [],
}

export const FILTER_LABEL_MAP = {
  cost: 'Relative cost',
  search: 'Search',
  location: 'Location',
  timeframe: 'Timeframe',
  lead_time: 'Lead Time',
  para_category: 'PARA Category',
  hazards_addressed: 'Hazards Addressed',
  risk_management_type: 'Risk Management Type',
}

export const DEFAULT_FILTER_MAP = {
  cost: 'All costs',
  search: 'search',
  location: 'All locations',
  timeframe: 'All timeframes',
  lead_time: 'All lead times',
  para_category: 'All PARA Categories',
  hazards_addressed: 'All hazards addressed',
  risk_management_type: 'All risk management types',
}

export const COSTS_MAP = {
  $: '$ Low',
  $$: '$$ Medium',
  $$$: '$$$ High',
}

export const HAZARDS_COLOUR_MAP = {
  'Surface flooding': {
    color: '#1E40AF',
    background: '#DBEAFE',
  },
  'Coastal / Fluvial flooding': {
    color: '#365314',
    background: '#ECFCCB',
  },
  Drought: {
    color: '#C2410C',
    background: '#FFEDD5',
  },
  Wildfire: {
    color: '#831843',
    background: '#FCE7F3',
  },
  'Extreme Wind': {
    color: '#312E81',
    background: '#E0E7FF',
  },
  Temperature: {
    color: '#854D0E',
    background: '#FEF9C3',
  },
  Rainfall: {
    color: '#064E3B',
    background: '#D1FAE5',
  },
}

export const PAGE_SIZE = 9
